export default function GTEX() {
    return (
        <div className="card">
            <h2>GT Endu Xperience (Platzhalter)</h2>
            <p>Hier folgt später die Endurance-Serie.</p>
        </div>
    );
}
